// import { gql } from '@apollo/client'
export const ROLE = `
    app {
        name
    }
  roleList {
    name
    attribute
    userField
    regisable
    roleType
    roleKey
    status
    isDefault
    isReplaceable
  }
`
export const PERMISSION = `
  name
  permissionKey
  code
`
